import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import { withAsyncActions } from 'react-async-client';
import Translate from 'react-translate-component';

import { getCourse } from 'actions/asyncActions';
import { fullAutoOptions } from 'constants/asyncClient';
import { DefinitionHeader } from 'components/common/fields/DefinitionHeader';
import { DefinitionField } from 'components/common/fields/DefinitionField';
import SidebarContainer from '../../SidebarContainer';
import EducationStages from '../EducationStages';
import YesNoField from 'components/common/fields/YesNoField';
import CourseButton from 'components/views/education/courseList/CourseButton';

@withAsyncActions({ getCourse: getCourse.withPayload(({ id }) => id) }, fullAutoOptions)
export default class CourseSidebarView extends Component {
    static propTypes = {
        id: PropTypes.number.isRequired,
        params: PropTypes.object,
        getCourse: PropTypes.object.isRequired,
    };

    getFooter = item => {
        return <CourseButton selectedItem={item} />;
    }

    render() {
        const { getCourse: { data, meta, refresh }, params: { title } } = this.props;
        const isIndividual = <YesNoField value={data.isIndividual} />;
        const needApproval = <YesNoField value={data.needApproval} />;
        const type = <Translate content={`education.courses.typeNumber.${data.type}`} />;
        const footer = meta.success && this.getFooter(data);

        return (
            <SidebarContainer meta={meta} refresh={refresh} title={title} footer={footer}>
                { meta.success &&
                    <Fragment>
                        <DefinitionHeader translate="common.general" iconType='info-outline' />
                        <div className="panel-view">
                            <DefinitionField translate="education.courses.type" text={type} />
                            <DefinitionField translate="education.courses.headers.isIndividual" text={isIndividual} />
                            <DefinitionField translate="education.courses.headers.needApproval" text={needApproval} />
                            <DefinitionField translate="education.courses.annotation" text={data.annotation} />
                            <DefinitionField translate="education.courses.createData" text={data.createData} />
                            <DefinitionField translate="education.courses.authors" text={data.authors} />
                            <DefinitionField translate="education.courses.duration" text={data.duration} />
                            <DefinitionField translate="education.courses.examType" text={data.examType} />
                            <DefinitionField translate="education.courses.requirments" text={data.requirments} />
                            <DefinitionField translate="education.courses.cost" text={data.cost} />
                            <DefinitionField translate="education.courses.costPerPerson" text={data.costPerPerson} />
                            <DefinitionField translate="education.courses.comment" text={data.comment} />
                            <DefinitionField translate="education.courses.goals" text={data.goals} />
                            <DefinitionField translate="education.courses.tasks" text={data.tasks} />
                            <DefinitionField translate="education.courses.resources" text={data.resources} />
                            <DefinitionField translate="education.courses.schedule" text={data.schedule} />
                            <DefinitionField translate="education.courses.trainer" text={data.trainer} />
                            <DefinitionField translate="education.courses.valuta" text={data.valuta} />
                        </div>
                        <EducationStages stages={data.stageList} />
                    </Fragment>
                }
            </SidebarContainer>
        )
    }
}
